import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { UserApiService } from 'src/app/services/api/user-api.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-user-profile-form-page',
  templateUrl: './user-profile-form-page.component.html',
  styleUrls: ['./user-profile-form-page.component.scss'],
})
export class UserProfileFormPageComponent implements OnInit {
  loading = false;

  tel = new FormControl('', Validators.required);
  account = new FormControl('', Validators.required);
  password = new FormControl('', Validators.required);
  name = new FormControl('', Validators.required);
  platform = new FormControl(null, Validators.required);
  bus = new FormControl(null, Validators.required);
  time = new FormControl('', Validators.required);
  whether = new FormControl('', Validators.required);
  sex = '先生';

  whetherData = [
    { label: '是', value: '是' },
    { label: '否', value: '否' },
  ];

  timeData = [
    { label: '尽快', value: '尽快' },
    { label: '3小时内', value: '3小时内' },
    { label: '12小时内', value: '12小时内' },
    { label: '24小时内', value: '24小时内' },
  ];

  constructor(private api: UserApiService, private message: MessageService) {
    this.platform.valueChanges.subscribe((id) => {
      this.getBus(id);
    });
  }

  ngOnInit(): void {
    this.findRechargePlatforms();
  }

  onChange(event: any) {
    this.sex = event;
  }

  error = false;

  submitLoading = false;
  async submit() {
    if (
      this.platform.invalid ||
      this.bus.invalid ||
      this.tel.invalid ||
      this.account.invalid ||
      this.password.invalid ||
      this.name.invalid ||
      this.whether.invalid ||
      this.time.invalid
    ) {
      this.tel.markAllAsTouched();
      this.account.markAllAsTouched();
      this.password.markAllAsTouched();
      this.name.markAllAsTouched();
      this.platform.markAllAsTouched();
      this.bus.markAllAsTouched();
      this.whether.markAllAsTouched();
      this.time.markAllAsTouched();
      return;
    }

    const platformID = this.platform.value || 0;
    const busID = this.bus.value || 0;
    const appellation = this.name.value + this.sex;
    const contactTime = this.time.value || '';
    const purchaseVerify = this.whether.value || '';
    const customerContact = this.tel.value || '';
    const email = this.account.value || '';
    const password = this.password.value || '';
    try {
      this.submitLoading = true;
      const r = await this.api.postForm(
        platformID,
        busID,
        appellation,
        contactTime,
        purchaseVerify,
        customerContact,
        email,
        password
      );
      if (r.status === 13007) {
        this.message.error('表单重复提交');
      } else if (r.status === 0) {
        this.message.open('提交成功');
        window.location.reload();
      }
    } catch (error) {
    } finally {
      this.submitLoading = false;
    }
  }

  platformData: any = [];
  async findRechargePlatforms() {
    try {
      this.loading = true;
      const r = await this.api.findRechargePlatforms();
      if (!r.data) {
        this.platformData.push({ label: '暂无数据', value: '' });
        return;
      }
      for (const item of r.data) {
        const itemData = { label: item.name, value: item.id };
        this.platformData.push(itemData);
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }

  busData: any = [{ label: '暂无数据', value: '' }];
  async getBus(id: any) {
    this.busData = [];
    try {
      this.loading = true;
      const r = await this.api.getBus(id);
      if (!r.data) {
        this.busData.push({ label: '暂无数据', value: '' });
        return;
      }
      for (const item of r.data) {
        const itemData = { label: item, value: item };
        this.busData.push(itemData);
      }
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
